import React from 'react';
import { useFlagService } from '@atlassian/jira-flags';
import { useIntlV2 as useIntl } from '@atlassian/jira-intl';
import { useIsAdmin } from '@atlassian/jira-tenant-context-controller';
import type { CopyModalProps } from '../common/types';
import FilterDataProvider from '../services/filter-data-provider';
import Content from './content';

function CopyModal(props: CopyModalProps) {
	const { id, onDataRetrieveFailed } = props;
	const flagService = useFlagService();
	const intl = useIntl();
	const isAdmin = useIsAdmin();

	return (
		<FilterDataProvider
			id={id}
			flagService={flagService}
			onDataRetrieveFailed={onDataRetrieveFailed}
			isAdmin={isAdmin}
		>
			{({ error, data }) => {
				if (error) {
					return null;
				}

				return data ? (
					<Content
						intl={intl}
						flagService={flagService}
						filter={data}
						isAdmin={isAdmin}
						{...props}
					/>
				) : null;
			}}
		</FilterDataProvider>
	);
}

export default CopyModal;
